<tg-mobile-full-screen-dialog [fixedHeader]="true">
  <h1 class="title" i18n="Hidden text clicks stats|title @@hiddenTextClicks.title">
    Статистика Читать продолжение
  </h1>
  @if (loading) {
    <tg-inline-loader></tg-inline-loader>
  }
  @if (stats && stats[data.channelId]) {
    <table>
      <thead>
        <tr>
          <th i18n="Hidden text clicks stats|header @@hiddenTextClicks.table.header.btn">Кнопка</th>
          <th i18n="Hidden text clicks stats|header @@hiddenTextClicks.table.header.clicks">Клики</th>
          <th i18n="Hidden text clicks stats|header @@hiddenTextClicks.table.header.uniqUsers">Уников</th>
          <th i18n="Hidden text clicks stats|header @@hiddenTextClicks.table.header.subscribe">Подписалось/осталось</th>
          <th i18n="Hidden text clicks stats|header @@hiddenTextClicks.table.header.notSubscribe">Не подписалось</th>
        </tr>
        @for (stat of stats[data.channelId]; track stat) {
          <tr>
            <td><b>{{data.buttons[stat.btnId]}}</b></td>
            <td>{{stat.allClicks}}</td>
            <td>{{stat.uniqClicks}}</td>
            <td>{{stat.subscribed}} / {{stat.stay}}</td>
            <td>{{stat.notSubscribed}}</td>
          </tr>
        }
      </thead>
    </table>
  }
</tg-mobile-full-screen-dialog>
